import { ProPlanModal } from "../modal/pro-plan/pro-plan-modal";
import { Button, ButtonProps } from "@chakra-ui/react";
import { useState } from "react";

export type ButtonOpenModal_T = ButtonProps;

export const ButtonOpenModal = (props: ButtonOpenModal_T) => {
  const { ...buttonProps } = props;

  const [isOpen, setOpen] = useState(false);
  const onClose = () => setOpen(false);

  return (
    <>
      <Button onClick={() => setOpen(true)} {...buttonProps} />
      <ProPlanModal {...{ isOpen, onClose }} />
    </>
  );
};
